import React, { useEffect, useState } from 'react';
import { Section, SectionHeading, PRICE_EUR } from './Shared';
import { Pricing } from './Pricing';
import { VolumeCard } from './VolumeCard';
import { BonusShowcase } from './BonusShowcase';
import { tomos } from '../data/packContents';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 0,
    s: 0
  });
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-156" data-mp="1wqte5xrcky11">
      <div className="bg-brand-purpleDark text-brand-goldLight font-mono font-semibold text-2xl md:text-4xl rounded-sm px-4 md:px-6 py-2.5 md:py-3.5 min-w-[64px] md:min-w-[88px] text-center tabular-nums border border-brand-gold/40" data-id="element-157" data-mp="1wlgvqglrtri3">
        {fmt(value)}
      </div>
      <span className="font-seal text-[11px] md:text-xs uppercase tracking-seal text-brand-muted mt-2" data-id="element-158" data-mp="2ajyh47o7erwu">
        {label}
      </span>
    </div>;
  return <div className="max-w-3xl mx-auto mb-14" data-id="element-159" data-mp="2firvs3f88oyl">
      <div className="glass-panel gold-frame rounded-sm p-6 md:p-10" data-id="element-160" data-mp="2kie541rxpl24">
        <p className="font-seal text-xs md:text-sm uppercase tracking-seal text-brand-goldDark text-center mb-6" data-id="element-161" data-mp="2kg9u6zvmblsc">
          Prezzo di lancio — si chiude tra
        </p>

        <div className="flex items-start justify-center gap-3 md:gap-5 mb-7" data-id="element-162" data-mp="2t9eisybmkqeu">
          <TimeBox value={timeLeft.h} label="Ore" data-id="element-163" data-mp="2yakd30kxolqh" />
          <span className="text-2xl md:text-3xl text-brand-purpleDark/40 pt-2" data-id="element-164" data-mp="2y7ofxegwu133">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Minuti" data-id="element-165" data-mp="336j4yy5h0lvn" />
          <span className="text-2xl md:text-3xl text-brand-purpleDark/40 pt-2" data-id="element-166" data-mp="137e7qwa2gnez">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Secondi" data-id="element-167" data-mp="y94e4q3zpuvh" />
        </div>

        <p className="text-center text-sm md:text-base text-brand-text/85 border-y border-brand-gold/30 py-3" data-id="element-168" data-mp="1cwpbs4i3j1w0">
          Il pack completo a{' '}
          <span className="text-brand-burgundy font-semibold" data-id="element-169" data-mp="183mhfu5hvoer">{PRICE_EUR}</span>{' '}
          — pagamento unico, accesso immediato dopo l’acquisto.
        </p>
      </div>
    </div>;
};
export const PackContents = () => <Section id="method" className="relative" data-id="element-170" data-mp="1hxvbima6bpf1">
    <SectionHeading eyebrow="Cosa ricevi" className="mb-10" data-id="element-171" data-mp="1vu8rfqz27ire">
      3 volumi principali + 5 bonus pratici inclusi
    </SectionHeading>

    <p className="text-center text-brand-text/70 text-base md:text-lg -mt-5 mb-10 font-display italic" data-id="element-172" data-mp="1qu487t6ro9xh">
      Oltre 300 pagine di contenuti visuali e operativi.
    </p>

    <div className="max-w-3xl mx-auto mb-16 space-y-3" data-id="element-173" data-mp="3sovdxm1r2iyv">
      {tomos.map(tomo => <VolumeCard key={tomo.n} tomo={tomo} data-id="element-174" data-mp="284zsfhnp85or" />)}
    </div>

    <div className="max-w-5xl mx-auto" data-id="element-175" data-mp="287m67z16nhff">
      <BonusShowcase data-id="element-176" data-mp="2d55nz8x3acc4" />
    </div>
  </Section>;
export const MethodOverview = () => <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full" data-id="element-177" data-mp="1yfpzy0oy0l04">
    <LaunchUrgency data-id="element-178" data-mp="1yfg7m6gfe1r9" />
    <Pricing data-id="element-179" data-mp="1ydvjozom9h2d" />
  </div>;